import styled from "styled-components";

export const container = styled.div`
    background: #FFFFFF;
    padding: 1rem 2rem;
    border-radius: 10px;
    display: flex;
    align-items: center;
    font-size: 2rem;
    position: relative;
    box-shadow: 0px 5px 1px 1px #F8F7FB;
    width: 100%;
    color: #FFCD8B;
    margin: 1.5rem 0;

    @media (max-width: 1250px){
        width: 100%;
        padding: 1rem 1rem;
    }

    
    .container-datas{
        margin: 0 2rem;
        p{
            font: 600 1.5rem 'Poppins', sans-serif;
            color: #545455;
        }

        span{
            font: 500 1.25rem 'Poppins', sans-serif;
            color: #E1E1E1;
        }

        @media (max-width: 1250px){
            margin: 0 1.5rem;
        }
    }

    .container-price{
        background: #FFDE8D;
        color: #F46B45;
        border-radius: 20px;
        padding: .2rem .8rem;
        font: 600 1.2rem 'Poppins', sans-serif;
        position: absolute;
        right: 1.5rem;
        top: 1rem;
        
        span{
            position: relative;
            bottom: .2rem;
            margin-right: .5rem;
            font: 600 1rem 'Poppins', sans-serif;
        }
    }

    @media (max-width: 567px){
        width: 70%;
        margin: 1.5rem 2vw;
    }

    @media (min-width: 567px) and (max-width: 766.98px){
        width: 60%;
        margin: 1.5rem 2vw;
    }

    @media (min-width: 767px) and (max-width: 998.98px){
        width: 40%;
        margin: 1.5rem 2vw;
    }

    @media (min-width: 999px) and (max-width: 1250px){
        .container-price{
            right: 1rem;
        }
    }
`